import dayjs from 'dayjs';
import useContainerProps from '../helpers/useContainerProps';
import { publish } from '../../pubsub';
import useRedirect from '../deeplink/useRedirect';
import usePopupOpener from '../helpers/usePopupOpener';

/**
 * FThis is an special function user click in listing or listing call to action
 * @param {Object} container
 * @param {Object} listing
 * @param {String} callToActionLabel
 */

export default (container, listing, date) => {
  const { eventType, fareItemInteractionType } = useContainerProps(container);
  const { start, end } = date;
  const dataToPublish = {};
  dataToPublish.guestCount = (listing && listing.guests) || 'n/a';
  dataToPublish.name = (listing && listing.placeDescription) || 'n/a';
  dataToPublish.roomCount = (listing && listing.bedrooms) || 'n/a';
  dataToPublish.starRating = (listing && listing.popularity) || 'n/a';
  if (start && end && dayjs(start).isValid() && dayjs(end).isValid()) {
    dataToPublish.tripLength = dayjs(end).diff(dayjs(start), 'day');
  }

  if (fareItemInteractionType === 'deeplink') {
    publish(`em.listing.book.${eventType}`, dataToPublish);
    useRedirect(container, listing);
  }
  if (fareItemInteractionType === 'popup') {
    usePopupOpener(dataToPublish);
    publish(`em.listing.book.${eventType}`, dataToPublish);
  }
};
